// @ts-strict-ignore
import { selectAuthCredentials } from '../../../selectors/selectors';
import { useSelector } from 'react-redux';
import * as API from '../../../api';
import { RootState } from '../../../reducers/reducers';
import { GetProvisioningProfilesResult } from '../../../types';
import { useState } from 'react';

export type GetProvisioningProfilesHookData = [
    GetProvisioningProfilesResult | undefined,
    boolean,
    Error,
    () => Promise<void>,
];

export const useGetProvisioningProfiles: (orgId: string, appId: string) => GetProvisioningProfilesHookData = (
    orgId,
    appId,
) => {
    const [result, setResult] = useState<GetProvisioningProfilesResult | undefined>(undefined);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));

    const startLoading = async () => {
        setIsLoading(true);
        setError(undefined);
        try {
            const apiResult = await API.getProvisioningProfiles({ orgId, appId }, authCredentials);

            setResult(apiResult);
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return [result, isLoading, error, startLoading];
};
